import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "My Book List", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Login")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Signup")
const _hoisted_7 = { key: 0 }

import { auth } from '@/firebase/config'
import { signOut } from '@firebase/auth'
import { getUser } from '@/composables/getUser'
import { useRouter } from 'vue-router'
import { watchEffect } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { user } = getUser()
const router = useRouter()

const handleClick = () => signOut(auth)

watchEffect(() => {
  if (!user.value && router.currentRoute.value.name != 'Signup') {
    router.push('/login')
  }
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", null, [
      _hoisted_1,
      (_unref(user))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createElementVNode("button", { onClick: handleClick }, "Logout")
          ]))
        : _createCommentVNode("", true),
      (!_unref(user))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_router_link, { to: "/login" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/signup" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(user))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, "logged in as " + _toDisplayString(_unref(user).email), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})